module.exports = __webpack_public_path__ + "img/third.cefd9931.jpg";